var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"is-uppercase",class:[_vm.isTag ? 'tag is-rounded' : '', _vm.colorClass, _vm.tagSize],attrs:{"title":_vm.$t(`card_payment_status.${_vm.status}`)}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:(`card_payment_status.${_vm.status}`),expression:"`card_payment_status.${status}`"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }